/** @jsxImportSource theme-ui */
import React, { useEffect, useState } from 'react';
import { Image } from 'theme-ui';
import BtnClose from '../../../assets/btnClose.svg';
import ScretchmeIcon from '../../../assets/images/stretchme_icon.png';
import { useTranslation } from 'react-i18next';

type MobilePlatform = 'android' | 'ios';

const APP_DEEP_LINK = 'yuuyoga://app';
const APP_STORE_URL =
  'https://apps.apple.com/us/app/stretchme-app/id1638365597';
const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.yuuyoga';

const AndroidPromoLink = (): JSX.Element => {
  const { t } = useTranslation();
  const [showComponent, setShowComponent] = useState(false);
  const [platform, setPlatform] = useState<MobilePlatform | null>(null);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const userAgent = window.navigator.userAgent;
      const detectedPlatform = /Android/i.test(userAgent)
        ? 'android'
        : /iPhone|iPad|iPod/i.test(userAgent)
        ? 'ios'
        : null;

      setPlatform(detectedPlatform);
      setShowComponent(detectedPlatform != null);
    }
  }, []);

  const openApp = (): void => {
    if (platform == null) return;

    const storeUrl = platform === 'ios' ? APP_STORE_URL : PLAY_STORE_URL;
    let fallbackTimer: number | undefined;

    const cancelFallback = (): void => {
      if (document.hidden) {
        if (fallbackTimer != null) window.clearTimeout(fallbackTimer);
        document.removeEventListener('visibilitychange', cancelFallback);
      }
    };

    document.addEventListener('visibilitychange', cancelFallback);
    window.location.href = APP_DEEP_LINK;
    fallbackTimer = window.setTimeout(() => {
      document.removeEventListener('visibilitychange', cancelFallback);
      window.location.href = storeUrl;
    }, 1500);
  };

  if (typeof window == 'undefined') {
    return <></>;
  }

  if (!showComponent || platform == null) {
    return <></>;
  }

  return (
    <div
      sx={{
        position: 'fixed',
        zIndex: 200,
        backgroundColor: 'white',
        top: 0,
        height: 80,
        borderBottom: '0.5px solid #efefef',
        width: '100vw',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
      }}
    >
      <div sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
        <div
          onClick={() => {
            setShowComponent(false);
          }}
          sx={{
            width: '15px',
            height: '15px',
            marginLeft: 2,
            marginRight: 1,
          }}
        >
          <Image src={BtnClose} />
        </div>
        <div
          sx={{
            width: '45px',
            height: '45px',
            marginLeft: 2,
            borderRadius: 10,
            overflow: 'hidden',
            marginRight: 1,
          }}
        >
          <Image src={ScretchmeIcon} />
        </div>
        <div
          sx={{
            height: '45px',
            marginLeft: 2,
            borderRadius: 10,
            overflow: 'hidden',
            maxWidth: '90px',
            marginRight: 1,
            fontSize: 14,
          }}
        >
          <p sx={{ margin: 0, marginTop: '2px' }}>Stretchme.app</p>
          <p sx={{ margin: 0, fontSize: 10, color: '#6f6f6f' }}>
            {t('android_promo_banner.desc')}
          </p>
        </div>
      </div>
      <div sx={{ alignItems: 'center', display: 'flex' }}>
        <button
          type="button"
          onClick={openApp}
          sx={{
            background: '#007afe',
            border: 0,
            borderRadius: 50,
            color: 'white !important',
            textDecoration: 'none',
            textTransform: 'uppercase',
            fontWeight: 'bold',
            padding: 1,
            paddingLeft: 2,
            paddingRight: 2,
            marginRight: 2,
            cursor: 'pointer',
            fontSize: 10,
          }}
        >
          {t('android_promo_banner.open')}
        </button>
      </div>
    </div>
  );
};

export default AndroidPromoLink;
